import React from 'react'
import {
  COLUMN_TYPES,
  Icon,
  reducers,
  constants,
  LOOKUP_TYPES,
} from '@adc/ui-morpheus'
import { VENUE_CHANGES } from '../../constants/tableTypes'
const {
  actionCellActionTypes: { ACTION_CELL_ACTION_TYPES },
} = constants

const defaultColProps = {
  width: 200,
  isResizable: true,
  isReorderable: true,
  isVisible: true,
  searchable: false,
}

export const tableConfig = {
  config: {
    entityKey: VENUE_CHANGES,
    primaryKeyField: 'id',
  },
  fieldDefinitions: [
    {
      name: 'Updated By',
      apiRef: 'updated_by',
      foreignKey: LOOKUP_TYPES.USER,
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColProps,
      },
    },
    {
      name: 'Updated On',
      apiRef: 'updated_date',
      columnDefinition: {
        type: COLUMN_TYPES.DATE,
        colProps: defaultColProps,
      },
    },
    {
      name: 'Field',
      apiRef: 'field',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColProps,
      },
    },
    {
      name: 'From',
      apiRef: 'from',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColProps,
      },
    },
    {
      name: 'To',
      apiRef: 'to',
      columnDefinition: {
        type: COLUMN_TYPES.TEXT,
        colProps: defaultColProps,
      },
    },
    {
      name: '',
      apiRef: '__actions__', // not api val
      isUiOnly: true,
      columnDefinition: {
        type: COLUMN_TYPES.ACTION,
        actions: [ACTION_CELL_ACTION_TYPES.DISPLAY_DETAILS],
        colProps: { width: 50, fixedRight: true, align: 'center' },
      },
    },
  ],
  filterClauses: [],
  sortBy: [
    {
      field: '',
      order: '',
    },
  ],
}

const columnAction =
  actionCellActionType =>
  (actionIndex, rowIndex, primaryId, data, onRowAction) =>
    (
      <Icon
        color='info'
        size='large'
        style={{ marginTop: -3, cursor: 'pointer' }}
        name='zoom'
        key={actionIndex}
        title='View Details'
        data-elm-id={`action_edit_${rowIndex}`}
        onClick={() =>
          onRowAction(actionCellActionType, rowIndex, primaryId, data)
        }
      />
    )

export const columnSelector = state =>
  state.fieldDefinitions
    .filter(field => field.columnDefinition)
    .map(col => {
      const column = {
        ...col.columnDefinition,
        ...{ field: col.apiRef, title: col.name },
      }
      if (column.actions) column.actions = column.actions.map(columnAction)
      if (col.dataType) column.dataType = col.dataType
      if (col.searchType) column.searchType = col.searchType
      if (col.options) column.options = col.options
      if (col.formatOptions) column.formatOptions = col.formatOptions
      return column
    })

export const getFilterClauses = state => state.filterClauses

export default reducers.dataTable.dataTable(VENUE_CHANGES, tableConfig)
